module.exports = __webpack_public_path__ + "img/pdf2.c74c6a37.svg";